import Vue from 'vue';
import { MediaQueries } from 'vue-media-queries';
import App from './App.vue';
import router from './router';
import store from './store';
// i18n
import i18n from './i18n/i18n';

// Firebase
import './vendors/firebase/firebase';

Vue.config.productionTip = false;

const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);

new Vue({
  router,
  store,
  i18n,
  mediaQueries,
  render: (h) => h(App),
}).$mount('#app');
